// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.ClientFieldSpec
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class ClientFieldSpecBase {
  /** Do NOT invoke directly, instead use strongly typed createClientFieldSpecBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.ClientFieldSpec";
  }
  initFromJson(json, deserializeContext) {
    this.initClientFieldSpec(json.fieldPath != null ? json.fieldPath : null, json.operation != null ? json.operation : null);
  }
  initClientFieldSpec(fieldPath, operation) {
    this._fieldPath = fieldPath;
    this._operation = operation;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["fieldPath"] = this._fieldPath;
    retVal["operation"] = this._operation;
    return retVal;
  }
  get fieldPath() {
    return this._fieldPath;
  }
  set fieldPath(value) {
    this._fieldPath = value;
  }
  get operation() {
    return this._operation;
  }
  set operation(value) {
    this._operation = value;
  }
}
//# sourceMappingURL=ClientFieldSpecBase.js.map
